import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function ArticleBestAgent() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <main className="bg-background-50">
      <article>
        <header className="w-full px-6 md:px-10 pt-24 pb-12 md:pt-32 md:pb-16 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-accent-500 transition-colors mb-6">
              <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
              <span>На главную</span>
            </Link>
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">Рейтинг</span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight">
              Лучшие агенты Китая 2026: рейтинг и сравнение
            </h1>
            <p className="mt-5 text-base md:text-lg text-foreground-500 leading-relaxed">
              Объективный рейтинг китайских агентов-посредников. Почему таблицы YOYBUY выигрывают у традиционных агентов по прозрачности и экономии.
            </p>
            <div className="mt-6 flex items-center gap-4 text-xs text-foreground-400">
              <span>Обновлено: Июль 2026</span>
              <span>·</span>
              <span>Время чтения: 7 минут</span>
            </div>
          </div>
        </header>

        <div className="w-full px-6 md:px-10 py-12 md:py-16">
          <div className="max-w-3xl mx-auto">

            <img
              src="https://readdy.ai/api/search-image?query=Golden%20trophy%20and%20award%20ribbon%20on%20marble%20pedestal%20with%20multiple%20product%20samples%20arranged%20around%2C%20award%20winner%20concept%2C%20dramatic%20warm%20spotlight%20on%20winner%2C%20competition%20championship%20aesthetic%2C%20golden%20and%20amber%20tones%2C%20prestigious%20product%20photography%2C%20recognition%20and%20excellence%20atmosphere&width=1200&height=600&seq=yoybuy-art-bestagent-hero&orientation=landscape"
              alt="Лучшие агенты Китая 2026"
              className="w-full rounded-3xl mb-10 object-cover"
            />

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">Рейтинг агентов для заказа из Китая</h2>
              <p className="text-base text-foreground-600 leading-relaxed mb-6">
                Мы составили объективный рейтинг на основе анализа комиссий, скорости обработки, прозрачности цен и удобства использования. <strong>YOYBUY Spreadsheet</strong> занимает особое место — это не просто агент, а система прямого доступа к данным.
              </p>

              <div className="space-y-4">
                {[
                  { rank: '1', name: 'YOYBUY Spreadsheet', score: '9.4/10', pros: 'Прямые цены поставщиков, 14 категорий, ежедневное обновление, без комиссии агента', cons: 'Требуется самостоятельность в выборе товаров', highlight: true },
                  { rank: '2', name: 'Superbuy', score: '7.8/10', pros: 'Развитая логистика, мобильное приложение, полное сопровождение', cons: 'Высокие комиссии 8-12%, дополнительные услуги платные', highlight: false },
                  { rank: '3', name: 'CSSBuy', score: '7.2/10', pros: 'Низкие базовые комиссии, большой опыт работы', cons: 'Ограниченный функционал, поддержка не всегда оперативна', highlight: false },
                  { rank: '4', name: 'Kakobuy', score: '6.8/10', pros: 'Удобный интерфейс, хорошая техподдержка', cons: 'Высокие комиссии, скрытые платежи за конвертацию валют', highlight: false },
                  { rank: '5', name: 'Wegobuy', score: '6.5/10', pros: 'Широкая география доставки, разные способы оплаты', cons: 'Комиссии выше среднего, медленная обработка в пиковые сезоны', highlight: false },
                ].map((item) => (
                  <div key={item.rank} className={`p-5 rounded-2xl ${item.highlight ? 'bg-accent-50 border border-accent-200' : 'bg-background-100'}`}>
                    <div className="flex items-center justify-between flex-wrap gap-3 mb-2">
                      <div className="flex items-center gap-3">
                        <span className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${item.highlight ? 'bg-accent-500 text-background-50' : 'bg-foreground-400 text-background-50'}`}>{item.rank}</span>
                        <h3 className={`text-base font-semibold ${item.highlight ? 'text-accent-800' : 'text-foreground-800'}`}>{item.name}</h3>
                      </div>
                      <span className={`text-sm font-bold px-3 py-1 rounded-full ${item.highlight ? 'bg-accent-200 text-accent-700' : 'bg-background-200 text-foreground-600'}`}>{item.score}</span>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-xs mt-3">
                      <div>
                        <span className="text-foreground-400">Плюсы:</span>
                        <p className="text-foreground-600 mt-0.5">{item.pros}</p>
                      </div>
                      <div>
                        <span className="text-foreground-400">Минусы:</span>
                        <p className="text-foreground-600 mt-0.5">{item.cons}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">Почему YOYBUY Spreadsheet — лидер рейтинга</h2>
              <p className="text-base text-foreground-600 leading-relaxed mb-4">
                В отличие от традиционных агентов, <Link to="/" className="text-accent-500 hover:underline">YOYBUY Spreadsheet</Link> не добавляет комиссию к цене товара. Вы платите ровно столько, сколько стоит товар у поставщика. Система таблиц даёт вам полный контроль над процессом закупок, а ежедневное обновление данных гарантирует актуальность информации.
              </p>
              <p className="text-base text-foreground-600 leading-relaxed">
                При регулярных закупках экономия на комиссиях может составлять тысячи долларов в год. Именно это делает YOYBUY Spreadsheet выбором №1 для опытных покупателей и предпринимателей.
              </p>
            </section>

            <div className="mt-14 p-8 bg-primary-500 rounded-3xl text-center">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">Выберите лучшее решение</h2>
              <p className="text-base text-background-50/80 mb-6 max-w-md mx-auto">
                Начните использовать YOYBUY Spreadsheet — лидер рейтинга 2026 года для закупок из Китая.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="px-7 py-3.5 rounded-full bg-background-50 text-primary-600 text-sm font-semibold hover:bg-accent-100 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center">
                  <span>YOYBUY SHEET</span>
                  <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
                </a>
                <Link to="/" className="px-7 py-3.5 rounded-full border-2 border-background-50/40 text-background-50 text-sm font-semibold hover:border-background-50 hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center">
                  <span>На главную</span>
                  <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
                </Link>
              </div>
            </div>

            <div className="mt-10 pt-10 border-t border-background-200">
              <Link to="/" className="inline-flex items-center gap-2 text-sm text-foreground-400 hover:text-accent-500 transition-colors">
                <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
                <span>← Вернуться на главную страницу YOYBUY.PRO</span>
              </Link>
            </div>
          </div>
        </div>
      </article>

      <footer className="w-full px-6 md:px-10 py-10 bg-foreground-950">
        <div className="max-w-3xl mx-auto text-center">
          <Link to="/" className="text-xl font-heading font-bold text-background-50">YOYBUY<span className="text-accent-500">.PRO</span></Link>
          <p className="mt-3 text-xs text-background-50/30">© 2026 YOYBUY.PRO. Все права защищены.</p>
        </div>
      </footer>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org", "@type": "Article",
          "headline": "Лучшие агенты Китая 2026: рейтинг и сравнение",
          "description": "Объективный рейтинг китайских агентов-посредников. Почему таблицы YOYBUY выигрывают.",
          "datePublished": "2026-07-05", "dateModified": "2026-07-05",
          "author": {"@type": "Organization", "name": "YOYBUY.PRO"},
          "publisher": {"@type": "Organization", "name": "YOYBUY.PRO"},
          "mainEntityOfPage": {"@type": "WebPage", "@id": `${import.meta.env.VITE_SITE_URL}/article/best-china-agent-2026`}
        })}
      </script>
    </main>
  );
}